import { render, staticRenderFns } from "./UpdateShipmentStatus.vue?vue&type=template&id=678be085&scoped=true"
import script from "./UpdateShipmentStatus.vue?vue&type=script&lang=js"
export * from "./UpdateShipmentStatus.vue?vue&type=script&lang=js"
import style0 from "./UpdateShipmentStatus.vue?vue&type=style&index=0&id=678be085&prod&scoped=true&lang=scss"
import style1 from "./UpdateShipmentStatus.vue?vue&type=style&index=1&id=678be085&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678be085",
  null
  
)

export default component.exports